const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Vite replaces import.meta.env.PROD at build time with `true` or `false`.
// In `vite build` output PROD === true; in `vite dev` PROD === false.
const isProductionBuild: boolean = import.meta.env.PROD === true;

export type RuntimeModeLabel = 'local' | 'supabase';

export const runtimeMode = {
  hasSupabaseUrl: Boolean(supabaseUrl),
  hasSupabaseAnonKey: Boolean(supabaseAnonKey),
  missingSupabaseEnvVars: [
    !supabaseUrl ? 'VITE_SUPABASE_URL' : null,
    !supabaseAnonKey ? 'VITE_SUPABASE_ANON_KEY' : null,
  ].filter(Boolean) as string[],
  get isSupabaseConfigured() {
    return this.hasSupabaseUrl && this.hasSupabaseAnonKey;
  },
  get isLocalDemoMode() {
    return !this.isSupabaseConfigured;
  },
  get label(): RuntimeModeLabel {
    return this.isSupabaseConfigured ? 'supabase' : 'local';
  },
  /** True when running a production/staging build without Supabase env vars.
   *  This is a dangerous state for real garage use — show a blocking guard. */
  get isProductionWithoutSupabase() {
    return isProductionBuild && !this.isSupabaseConfigured;
  },
};
